import { Controller } from "@hotwired/stimulus"
import { isAbortError, rethrowUnlessAbort } from "../../utils/fetch-error.util"

export default class extends Controller {
  static targets = ["toggle", "packRadio", "status"]
  static values = { autoBuyUrl: String, autoRenewUrl: String, enabled: Boolean, currentSlug: String }

  // The promise is returned only so tests can await the request; Stimulus
  // ignores it, so an unhandled rejection still reaches the global error handler.
  toggleAutoBuy(event) {
    return this.#postToggle(event, this.autoBuyUrlValue, "auto_buy_enabled", "auto_buy_pack_slug")
  }

  toggleAutoRenew(event) {
    return this.#postToggle(event, this.autoRenewUrlValue, "auto_renew_enabled", "auto_renew_pack_slug")
  }

  selectedPackSlug() {
    const checked = this.packRadioTargets.find((r) => r.checked)
    return checked ? checked.value : null
  }

  #postToggle(event, url, enabledParam, slugParam) {
    const checkbox = event.target
    const enabled = checkbox.checked
    const selectedSlug = this.selectedPackSlug()

    const formData = new FormData()
    formData.append(enabledParam, enabled ? "true" : "false")
    if (enabled && selectedSlug) {
      formData.append(slugParam, selectedSlug)
    }

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    return fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/html"
      },
      body: formData
    })
      .then((response) => {
        // fetch resolves for 4xx/5xx too. Without this, a rejected toggle
        // (non-owner, validation failure, 500) would look like success and the
        // checkbox would keep claiming a change the server never made.
        if (!response.ok) throw new Error(`Auto-buy toggle failed: HTTP ${response.status}`)

        if (response.redirected) {
          window.location.href = response.url
        }
      })
      .catch((error) => {
        // A real failure leaves the toggle lying about server state, so put it
        // back. An abort only means the user navigated away mid-request — the
        // page is going anyway, and flipping the checkbox would be a lie of its
        // own. Re-raise so real failures still reach monitoring.
        if (!isAbortError(error)) {
          checkbox.checked = !enabled
        }
        rethrowUnlessAbort(error)
      })
  }
}
